// src/CompanyRegister/Step3.js
import React, { useState } from "react";
import { toast } from "sonner";
import { Card, CardContent } from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { X } from "lucide-react";

const Step3 = ({ onNext, onBack, formData }) => {
  const [productos, setProductos] = useState(formData?.productos || []);
  const [servicios, setServicios] = useState(formData?.servicios || []);
  const [inputProducto, setInputProducto] = useState("");
  const [inputServicio, setInputServicio] = useState("");

  const handleAddProducto = () => {
    if (productos.length >= 20) {
      toast.warning("Has alcanzado el límite máximo de 20 productos.");
      return;
    }
    if (!inputProducto.trim()) return;
    setProductos([...productos, inputProducto.trim()]);
    setInputProducto("");
  };

  const handleAddServicio = () => {
    if (servicios.length >= 20) {
      toast.warning("Has alcanzado el límite máximo de 20 servicios.");
      return;
    }
    if (!inputServicio.trim()) return;
    setServicios([...servicios, inputServicio.trim()]);
    setInputServicio("");
  };

  const handleRemoveProducto = (index) => {
    setProductos(productos.filter((_, i) => i !== index));
  };

  const handleRemoveServicio = (index) => {
    setServicios(servicios.filter((_, i) => i !== index));
  };

  const handleNext = () => {
    onNext({ productos, servicios });
  };

  const handleBack = () => {
    onBack({ productos, servicios }); // Envía los datos actuales al componente padre
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-6">
        <h3 className="text-xl font-semibold text-foreground">Paso 3: Productos y Servicios (opcional)</h3>
        <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
          <div>
            <label className="mb-1.5 block text-sm font-medium text-foreground">
              Principales productos que ofrece la empresa (escribe y luego dale
              click a "Añadir Producto")
            </label>
            <div className="flex gap-2">
              <Input
                type="text"
                value={inputProducto}
                onChange={(e) => setInputProducto(e.target.value)}
                placeholder="Ejemplo: Transporte de mercancías, equipos industriales"
                maxLength={500}
              />
              <Button type="button" variant="outline" onClick={handleAddProducto}>
                Añadir Producto
              </Button>
            </div>
            {productos.length > 0 && (
              <ul className="mt-2 space-y-1">
                {productos.map((producto, index) => (
                  <li key={index} className="flex items-center gap-2 text-sm text-muted-foreground">
                    {producto}
                    <button type="button" onClick={() => handleRemoveProducto(index)} className="hover:text-destructive">
                      <X className="h-3.5 w-3.5" />
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div>
            <label className="mb-1.5 block text-sm font-medium text-foreground">
              Principales servicios que ofrece la empresa (escribe y luego dale
              click a "Añadir Servicio")
            </label>
            <div className="flex gap-2">
              <Input
                type="text"
                value={inputServicio}
                onChange={(e) => setInputServicio(e.target.value)}
                placeholder="Ejemplo: Transporte de personal, mantenimiento"
                maxLength={500}
              />
              <Button type="button" variant="outline" onClick={handleAddServicio}>
                Añadir Servicio
              </Button>
            </div>
            {servicios.length > 0 && (
              <ul className="mt-2 space-y-1">
                {servicios.map((servicio, index) => (
                  <li key={index} className="flex items-center gap-2 text-sm text-muted-foreground">
                    {servicio}
                    <button type="button" onClick={() => handleRemoveServicio(index)} className="hover:text-destructive">
                      <X className="h-3.5 w-3.5" />
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="flex justify-between">
            <Button type="button" variant="outline" onClick={handleBack}>
              Retroceder
            </Button>
            <Button type="button" onClick={handleNext}>
              Siguiente
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default Step3;
